import { render } from "./SpringRuleEdit.vue?vue&type=template&id=2c106e08&scoped=true&ts=true"
import script from "./SpringRuleEdit.vue?vue&type=script&lang=ts"
export * from "./SpringRuleEdit.vue?vue&type=script&lang=ts"

import "./SpringRuleEdit.vue?vue&type=style&index=0&id=2c106e08&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c106e08"]])

export default __exports__